import * as stylex from "@stylexjs/stylex";
import { TOC } from "components/hero-vis/TOC";
import { FormattedMessage } from "react-intl";
import * as M from "../../materials";
import { breakpoints, layoutAreas, zIndex } from "../../materials/consts.stylex";
import { themeVars } from "../../materials/theme.stylex";
import { typography } from "../../materials/typography.stylex";
import { O, pipe } from "../../prelude";
import { findArticleAlias, findArticleThemeAlias, subthemesIndex, useAlias } from "../../routes";
import { RelatedFocus } from "./related-focus";
import { RelatedSubthemeArticle } from "./related-subtheme";
const arrowUrl = new URL("../../icons/svg/ic_link-external_22dp.svg", import.meta.url).href;
const stylexStyles = {
    title: {
        kMwMTN: "x1rbwscb",
        kLKAdn: "x1p5oq8j",
        kGO01o: "xzk7aed",
        $$css: true
    },
    root: {
        kWkggS: "x19t24eb",
        kMwMTN: "x1mqxbix",
        $$css: true
    }
};
export function RelatedMaterial({ children }) {
    const alias = useAlias();
    const aliasRouteO = findArticleAlias(alias);
    const isInSubtheme = pipe(aliasRouteO, O.fold(()=>false, (a)=>subthemesIndex[findArticleThemeAlias(a)].length > 1));
    return <>
      <div className="x7wzq59 x191j7n5 xsmmsbn xb3hw6p">
        <TOC/>
      </div>
      <RelatedFocus/>
      {isInSubtheme && <RelatedSubthemeArticle/>}
      <>
        <M.Grid layout={"home"} // Grid's own baseStyles sets `margin-top: 0 !important` — only another
    // `!important` declaration can outrank that, so it lives in style.global.css,
    // scoped by this marker class (see the comment there for details).
    className="related-material-root" sx={[
        stylexStyles.root
    ]}>
          <div className="x1uq3dmu xdt5ytf x78zum5 xl56j7k x6s0dn4 x1ghz6dp xcnul9r">
            {pipe(aliasRouteO, O.map((articleAlias)=><img key="a" alt="" className="xjp8j0k" src={M.themes[articleAlias].illustration}/>), O.toNullable)}
            <h2 {...stylex.props(typography.heading2, stylexStyles.title)}>
              <FormattedMessage id="Related content" defaultMessage="Related content"/>
            </h2>
            { /* MDX children — StyleX can't reach the rendered <li>/<a> elements directly,
             * so their styles live in style.global.css, scoped by this marker class. The
             * arrow icon URL is passed through as a custom property since it comes from a
             * webpack asset import, not a value StyleX can inline at compile time. */ }
            <div className={`related-material-links ${({
        className: "xh8yej3 x161sli9"
    }).className}`} style={{
        "--related-material-arrow": `url(${arrowUrl})`
    }}>
              {children}
            </div>
          </div>
        </M.Grid>
      </>
    </>;
}
